import { Subject } from 'rxjs';
import { EVENT_COMMUNICATION_NAMESPACE } from '../../model/event-communication.model';
import * as i0 from "@angular/core";
import * as i1 from "@savvaslearning/lst-events";
export class EventCommunicationService {
    constructor(lstEventService) {
        this.lstEventService = lstEventService;
        this.handleParentEvents = new Subject();
        this.realizeOverviewRrsInstance$ = this.lstEventService.getObservable(EVENT_COMMUNICATION_NAMESPACE.REALIZE_OVERVIEW_RRS);
        this.handleParentEvents$ = this.handleParentEvents.asObservable();
    }
    handleParentEvent(eventData) {
        this.handleParentEvents.next(eventData);
    }
    sendEventToParent(eventData) {
        this.lstEventService.publishData(eventData, this.realizeOverviewRrsInstance$);
    }
}
EventCommunicationService.ɵfac = function EventCommunicationService_Factory(t) { return new (t || EventCommunicationService)(i0.ɵɵinject(i1.LstEventsService)); };
EventCommunicationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EventCommunicationService, factory: EventCommunicationService.ɵfac, providedIn: 'root' });
